import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { menuItems } from './constants';
import Logo from '../../../assets/caleta-en-linea-nuevo-logo.jpg';
import {uiContext} from '../../../components/common/';
import CircleDotSolid from '../../../assets/iconCircleDotSolid.PNG';
import CircleSolid from '../../../assets/iconCircleSolid.PNG';
import './LateralMenu.scss';

export function LateralMenu() {
  /**
   * Componente Menu Lateral
   * Aqui se muestran las direntes opciones que tiene el administrador
   */
  const [menu, setMenu] = useState(menuItems);
  const {showMenu, setShowMenu} = useContext(uiContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const handleShow = (id) => {
    const newMenu = menu.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          show: !item.show
        }
      }

      return item;
    });

    setMenu(newMenu);
  }

  window.onresize = ()=> setWindowWidth(window.innerWidth);

  if(showMenu && windowWidth < 990){
    return (
    <nav className={ 'navigation-mobile' }>
    <div className='list'>
      {
        menu.map((item) => (
          <div key={item.id}>
            <p>
              <img src={CircleDotSolid} alt={item.name} />
              {item.name}
            </p>            
            <div className='content-item'>
              {
                item.show && item.links.map((link, index) => (
                  <Link 
                    key={-2}
                    to={link.path} 
                    onClick={()=> setShowMenu(false)}>
                      <img src={CircleSolid} alt={link.name} />
                      {link.name}
                  </Link>
                ))
              }
            </div>
          </div>
        ))
      }
          <Link
            to={{ pathname: '/' }}
            key={-1}
            onClick={() => {
              setShowMenu(false);
              localStorage.removeItem("sessionToken");
              localStorage.removeItem("userId");
            }}>
            <img src={CircleDotSolid} alt={'salir'} />
            Salir
          </Link>
    </div>
  </nav>
    )
  }

  return (
    <nav className={ 'navigation' }>
      <img src={Logo} alt="Logo" className='logo' 
      />
      <div className='list'>
        {
          menu.map((item) => (
            <div key={item.id}>
              <button onClick={() => handleShow(item.id)}>
                <img src={item.icon} alt={item.name} />
                <p>{item.name}</p>
              </button>
              {
                item.show && item.links.map((link, index) => (
                  <Link to={link.path} key={index}>
                    {link.name}
                  </Link>
                ))
              }
            </div>
          ))
        }
        <Link 
          to={{ pathname: '/' }}
          onClick={() => {
            setShowMenu(false);
            localStorage.removeItem("sessionToken");
            localStorage.removeItem("userId");
          }}>
          Salir
        </Link>
      </div>
    </nav>
  )
}